import { render, staticRenderFns } from "./NotificationAppointmentCancelled.vue?vue&type=template&id=27745556&scoped=true&"
import script from "./NotificationAppointmentCancelled.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentCancelled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27745556",
  null
  
)

export default component.exports